export default "__VITE_ASSET__3219afdf__"